export const formatAmount = (amount: number, locale: string = 'tr') => {
  const localeMap = {
    'tr': 'tr-TR',
    'en': 'en-US'
  };
  
  return amount.toLocaleString(localeMap[locale as keyof typeof localeMap] || 'tr-TR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
}; 